<template>
    <v-alert type="error"> {{ error }} </v-alert>
</template>

<script>
export default {
    name: "ErrorHandling",
    props: ["error"]
}
</script>